<template>
  <form
    @submit.prevent="handleSubmit"
    name="credit-form"
    class="clearfix">
    <div class="col-md-12 clearfix">
      <h4 class="title-manage-account">Novo Cartão</h4>
    </div>
    <!-- Alert Helper -->
    <div class="col-xs-12 clearfix">
      <alert-helper
        :alert="alert"
        :close="true"
        type="danger"></alert-helper>
    </div>
    <!-- // Alert Helper -->
    <div class="col-md-10 col-sm-10 col-xs-10">
      <!-- Número do cartão -->
      <input-field
        :submitted="submitted"
        :field.sync="card.number"
        :required="true"
        :mask="['#### #### #### ####', '#### #### #### ###', '#### #### #### ##']"
        label="Número do cartão"
        type="text"
        name="number"
        validate="required"
        onpaste="return false"
        ondrop="return false"></input-field>
      <!-- / Número do cartão -->
    </div>
    <div class="col-md-2 col-sm-2 col-xs-2">
      <div class="box-credit-card-img">
        <img
          class="active card-img-box"
          src="@/assets/img/logo-mastercard.png"
          alt="Masterform"
          title="Masterform"
          v-if="card.card_type === 'mastercard'" />
        <img
          class="active card-img-box"
          src="@/assets/img/logo-visa.png"
          alt="Visa"
          title="Visa"
          v-if="card.card_type === 'visa'" />
        <img
          class="active card-img-box"
          src="@/assets/img/credit-icons/american-express-straight-128px.png"
          alt="Amex"
          title="Amex"
          v-if="card.card_type === 'amex'" />
      </div>
    </div>

    <div class="col-md-10">
      <!-- Nome impresso no cartão -->
      <input-field
        :submitted="submitted"
        :field.sync="card.name"
        :required="true"
        :validate="'required'"
        label="Nome impresso no cartão"
        type="text"
        name="name"></input-field>
      <!-- / Nome impresso no cartão -->
    </div>

    <div
      v-if="(card.is_corporate && card.is_corporate_physical) || !card.is_corporate"
      class="col-md-2">
      <!-- Código de Segurança -->
      <input-field
        :submitted="submitted"
        :field.sync="card.code"
        :mask="(card.card_type === 'amex') ? ['####'] : ['###']"
        :required="true"
        :validate="'required'"
        label="CVV"
        type="tel"
        name="code"
        onpaste="return false"
        ondrop="return false"
        maxlength="4"></input-field>
      <!-- / Código de Segurança -->
    </div>

    <template v-if="creditCardByProduct">
      <div class="col-sm-6">
        <!-- Tipo de Cartão -->
        <radio-field
          :submitted="submitted"
          :field.sync="card.is_corporate"
          :required="true"
          :options="options.isCorporate"
          label="Seu cartão é:"
          name="is_corporate"
          validate="required"></radio-field>
        <!-- / Tipo de Cartão -->

        <template
          v-if="card.is_corporate">
          <radio-field
            :submitted="submitted"
            :field.sync="card.is_corporate_physical"
            :required="true"
            :options="options.isCorporatePhysical"
            label="do tipo:"
            name="is_corporate_physical"
            validate="required"></radio-field>
        </template>

        <div
          v-if="!card.is_corporate_physical && card.is_corporate">
          <radio-field
            :submitted="submitted"
            :field.sync="corporate_virtual"
            :required="true"
            :options="options.corporateVirtual"
            label="especí­fico para:"
            name="corporate_virtual"
            validate="required"></radio-field>
        </div>
      </div>
    </template>

    <div
      :class="[{ 'col-sm-6' : creditCardByProduct }, { 'col-sm-12' : !creditCardByProduct }]">
      <div class="row">
        <label class="col-xs-12 theme-form-label">Validade*</label>
        <!-- Data de validade -->
        <div class="col-xs-6">
          <select-month
            :submitted="submitted"
            :field.sync="card.expiry_month"
            :required="true"
            :validate="'required'"
            name="expiry_month"></select-month>
        </div>
        <div class="col-xs-6">
          <select-year
            :submitted="submitted"
            :field.sync="card.expiry_year"
            :required="true"
            :validate="'required'"
            name="expiry_year"></select-year>
        </div>
      </div>
      <!-- / Data de validade -->
    </div>

    <div
      v-if="creditCardByProduct"
      class="col-sm-12 mb-10 padding-off">
      <div
        v-if="card.is_corporate && card.is_corporate_physical"
        class="col-sm-6">
        <!-- Shared -->
        <checkbox-field
          :submitted="submitted"
          :field.sync="card.corporate_parcel_allowed"
          :value="card.corporate_parcel_allowed"
          :checked="card.corporate_parcel_allowed"
          value-label="É permitido parcelar?"
          name="corporate_parcel_allowed"></checkbox-field>
        <!--/ Shared -->
      </div>
      <div class="col-sm-6">
        <!-- Shared -->
        <checkbox-field
          :submitted="submitted"
          :field.sync="card.is_shared"
          :value="card.is_shared"
          :checked="card.is_shared"
          value-label="Liberar para todos os viajantes?"
          name="is_shared"></checkbox-field>
        <!--/ Shared -->
      </div>
    </div>

    <div class="clearfix">
      <div class="col-sm-12 mb-5 mt-5">
        <small>*Campos obrigatórios</small>
      </div>
      <div class="col-sm-12 mb-20 padding-off">
        <!-- Parent Action -->
        <slot :handleParentAction="() => $emit('handleParentAction')"></slot>
        <!-- // Parent Action -->
        <div class="col-xs-6">
          <button
            :disabled="disabled"
            type="submit"
            class="btn-blue btn-block btn-extra-large">
            Salvar
          </button>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import { mapActions } from 'vuex'
import AlertHelper from '@/components/ui/AlertHelper'
import InputField from '@/components/fields/InputField'
import RadioField from '@/components/fields/RadioField'
import CheckboxField from '@/components/fields/CheckboxField'
import SelectMonth from '@/components/fields/SelectMonth'
import SelectYear from '@/components/fields/SelectYear'
import cardValidator from 'card-validator'

export default {
  props: [ 'creditCardByProduct' ],
  components: {
    AlertHelper,
    InputField,
    RadioField,
    CheckboxField,
    SelectMonth,
    SelectYear
  },
  data () {
    return {
      card: {
        is_corporate: false,
        is_corporate_physical: true,
        corporate_parcel_allowed: false,
        corporate_virtual_flight: false,
        corporate_virtual_hotel: false,
        /* FROM ORIGINAL MIXINS */
        number: null,
        name: null,
        code: null,
        expiry_month: '',
        expiry_year: '',
        card_type: null,
        is_shared: false
      },
      corporate_virtual: null,
      invalid: false,
      submitted: false,
      disabled: false,
      alert: null,
      /**/
      options: {
        isCorporate: [
          { value: false, label: 'Pessoal' },
          { value: true, label: 'Corporativo' }
        ],
        isCorporatePhysical: [
          { value: true, label: 'Fí­sico' },
          { value: false, label: 'Virtual' }
        ],
        corporateVirtual: [
          { value: true, label: 'Aéreo' },
          { value: false, label: 'Hotel' }
        ]
      }
    }
  },
  watch: {
    'card.number' () {
      this.validateCard()
    },
    'card.is_corporate' () {
      this.card.is_corporate_physical = true
      this.card.corporate_parcel_allowed = false
    },
    'card.is_corporate_physical' (data) {
      this.corporate_virtual = null
      this.card.corporate_parcel_allowed = false
      if (!data && !this.card.code) {
        this.card.code = 123
      }
    },
    corporate_virtual (data) {
      if (data === null) {
        this.card.corporate_virtual_hotel = false
        this.card.corporate_virtual_flight = false
      } else if (data ) {
        this.card.corporate_virtual_hotel = false
        this.card.corporate_virtual_flight = true
      } else {
        this.card.corporate_virtual_hotel = true
        this.card.corporate_virtual_flight = false
      }
    }
  },
  methods: {
    ...mapActions('creditcard', [
      'postCreditcard'
    ]),
    handleParent () {
      this.$ga.event({
        eventCategory: 'Cards',
        eventAction: 'Created',
        eventLabel: 'New Card Created',
        eventValue: 1
      })

      if (this.$listeners && this.$listeners.handleParentAction) {
        this.$emit('handleParentAction')
      }
    },
    handleSubmit () {
      this.alert = null

      this.$validator.validate().then(valid => {
        this.submitted = true

        if (valid) {
          this.disabled = true

          this.postCreditcard(this.card)
            .then(this.handleParent)
            .catch(error => {
              let last_error = false

              if (error.message) {
                last_error = error.message
              } else {
                for (let key in error) {
                  let error_field = error[key]
                  error_field.forEach(function(error) {
                    if (last_error == false) {
                      last_error = error
                    }
                  })
                }
              }

              if (last_error) {
                this.alert = last_error
              }
              this.disabled = false
            })
        }
      })
    },
    validateCard () {
      if (this.card.number.length < 4) {
        this.card.card_type = null
        this.invalid = false
      }
      if (this.card.number.length > 4) {
        let numberValidation = cardValidator.number(this.card.number)

        if (!numberValidation.isPotentiallyValid) {
          this.invalid = true
        }

        if (numberValidation.card) {
          this.card.card_type = numberValidation.card.type
          if (this.card.card_type === "american-express") {
            this.card.card_type = "amex"
          }
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/scss/components/forms/ScopedForms';
</style>
